<template>
    <div style="padding-bottom: 70px;">
        <Query :reload="reload" @query-click="handleQueryClick" @updata="handleUpdata" :tags="tagsActive" />
        <div v-loading="loading">
            <ObliqueTags :tags="tags" v-model="tagsActive" @tab-click="handleTabClick" />
            <!-- workOrder_v4：组内分配水位（组长看组员未来 5 个工作日已分配素材数/人均产能·组员卡片） -->
            <AssignMemberWater ref="water" />
            <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5 order_table_no_border">
                <jt-table :data="tableData" style="width: 100%"
                    :header-cell-style="{ background: '#e8eaec', color: '#333' }" size="mini"
                    @sort-change="handlesortchange" @header-dragend="handleDragEnd" header-cell-class-name="header-cell" class="setSortHeight" border
                          @selection-change="handleSelectionChange"
                    stripe ref="refs_table">
                    <!-- 操作区随表头一起吸顶（workOrder_v5 §11 扩展·jt-table affix-prepend 插槽） -->
                    <template #affix-prepend>
                        <div class="operation-box op-box-in-affix">
                            <div class="operation-left">
                                <template v-if="tagsActive == 1">
                                    <el-button type="primary" size="mini" v-if="getCurAuth('work_order_assign')" plain
                                               v-matomo="{behaviorCategory: '素材工单(指派管理-待指派)', event: '点击',  name: '批量指派' }"
                                               @click="batchAssign">批量指派</el-button>
                                    <el-button type="danger" size="mini" v-if="getCurAuth('reject_work_order')" plain
                                               v-matomo="{behaviorCategory: '素材工单(指派管理-已指派)', event: '点击',  name: '批量驳回' }"
                                               @click="batchReject">批量驳回</el-button>
                                </template>
                                <template v-else-if="tagsActive == 2">
                                    <el-button type="primary" size="mini" v-if="getCurAuth('work_order_assign')" plain
                                               v-matomo="{behaviorCategory: '素材工单(指派管理-已指派)', event: '点击',  name: '批量改派' }"
                                               @click="batchChangeAssign">批量改派</el-button>
                                    <el-button type="danger" size="mini" v-if="getCurAuth('reject_work_order')" plain
                                               v-matomo="{behaviorCategory: '素材工单(指派管理-已指派)', event: '点击',  name: '批量驳回' }"
                                               @click="batchReject">批量驳回</el-button>
                                </template>
                                <el-button
                                    type="primary"
                                    size="mini"
                                    v-if="getCurAuth('work_order_label_edit')" plain
                                    v-matomo="{behaviorCategory: '素材工单', event: '点击',  name: '修改工单标签' }"
                                    @click="handleTagEdit(multipleSelection)"
                                >
                                    修改工单标签
                                </el-button>
                            </div>
                            <div class="operation-right">
                                <el-button icon="el-icon-s-operation" size="mini" @click="handleFieldTable">自定义列</el-button>
                                <el-button icon="el-icon-download" size="mini" :loading="exportLoading"
                                    @click="exportData">导出</el-button>
                            </div>
                        </div>
                    </template>
                    <!-- v-if="tagsActive == 1||tagsActive == 2" -->
                    <el-table-column type="selection" width="55" >
                    </el-table-column>
                    <!-- 默认 -->
                    <el-table-column :prop="column.id" :label="column.display_name" :width="getLocalStorageWidth[column.id] || column.width"
                        :fixed="column.fixed != '' ? column.fixed : false" :sortable="getsortable(column.id)"
                        v-for="(column, index) in columns" :key="index">
                        <template slot="header" slot-scope="scope">
                            <el-tooltip effect="dark" placement="top" v-if="column.id=='company_name'||column.id=='bloc_name'">
                                <span>{{column.display_name}} <i class="el-icon-question"></i></span>
                                <div slot="content">
                                    <div v-if="column.id=='company_name'">
                                        <p>客户名称取值逻辑：</p>
                                        <p>1、如果有消耗：取选择的项目创建时近30天有消耗的账户对应的客户。</p>
                                        <p>2、如果无消耗：取选择的项目在聚投绑定的客户。</p>
                                    </div>
                                    <div v-else>
                                        <p>集团名称取值逻辑：</p>
                                        <p>1、如果有消耗：取选择的项目创建时近30天有消耗的账户对应的客户对应的集团。</p>
                                        <p>2、如果无消耗：取选择的项目在聚投绑定的客户对应的集团。</p>
                                    </div>
                                </div>
                            </el-tooltip>
                            <span v-else-if="column.id=='special_content'" class="text-color-error">{{column.display_name}}</span>
                            <span v-else>{{column.display_name}}</span>
                        </template>
                        <template slot-scope="scope">
                            <div v-if="column.id == 'urgent_level_text'">
                                <span v-if="scope.row['urgent_level'] == 2" style="color: #ff0000;"
                                    @dblclick="copyText(scope.row[column.id])">{{ scope.row[column.id] }}</span>
                                <span v-else @dblclick="copyText(scope.row[column.id])">{{ scope.row[column.id]
                                }}</span>
                            </div>
                            <div v-else-if="column.id == 'pass_material_num'"
                                @dblclick="copyText(`${scope.row['pass_material_num']}/${scope.row['material_num']}`)">
                                <span style="color: #409EFF;padding-right: 5px;">{{ scope.row['pass_material_num']
                                }}</span>/
                                <span>{{ scope.row['material_num'] }}</span>
                            </div>
                            <div v-else-if="column.id == 'expected_end_time'"
                                @dblclick="copyText(`${scope.row['expected_end_time']}`)">
                                <span :style="{color: formatDateColor(scope.row['expected_end_time'])}">{{ scope.row['expected_end_time'] }}</span>
                            </div>
                            <div v-else-if="column.id == 'material_status_num'">
                                <div v-if="scope.row['material_status_num'] == '-'">
                                    <span @dblclick="copyText(scope.row['material_status_num'])">{{
                                        scope.row['material_status_num'] }}</span>
                                </div>
                                <div v-else
                                    @dblclick="copyText(`(${scope.row['no_upload_material_num']}，${scope.row['no_audit_material_num']}，${scope.row['pass_material_num']})/${scope.row['material_num']}`)">
                                    <span style="color: #409EFF;cursor: pointer;"
                                        @click="handleRouteInfo(scope.row, false)">({{
                                            scope.row['no_upload_material_num'] }}</span>，
                                    <span style="color: #f56c6c;cursor: pointer;"
                                        @click="handleRouteInfo(scope.row, true, 'no_audit_list')">{{
                                            scope.row['no_audit_material_num'] }}</span>，
                                    <span style="color: rgb(103, 194, 58);cursor: pointer;padding-right: 5px;"
                                        @click="handleRouteInfo(scope.row, true, 'pass_list')">{{
                                            scope.row['pass_material_num'] }})</span>/
                                    <span style="">{{ scope.row['material_num'] }}</span>
                                </div>
                            </div>
                            <div v-else-if="column.id == 'material_create_user'">
                                <div v-if="scope.row[column.id] && Array.isArray(scope.row[column.id])">
                                    <div v-for="(item, i) in scope.row[column.id]" :key="i" @dblclick="copyText(item)">
                                        {{ item }}</div>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <material-label-cell v-else-if="column.id == 'material_label'" :v="scope.row.material_label" @copy="copyText"/>
                            <div v-else-if="column.id == 'work_order_label'" >
                                <div class="tab-box">
                                    <template v-for="item in scope.row['work_order_label']">
                                        <el-tag type="warning" :key="item.id" style="margin-right: 4px">{{item.name}}</el-tag>
                                    </template>
                                    <template v-if="!scope.row['work_order_label']?.length">-</template>
                                    <i v-if="getCurAuth('work_order_label_edit')"  @click="handleTagEdit([scope.row])" class="el-icon-edit-outline"></i>
                                </div>
                            </div>
                            <div v-else-if="column.id == 'controls'">
                                <el-button type="text" size="mini" v-if="getCurAuth('work_order_assign')"
                                    :style="{ color: '#409EFF' }" @click="handleInfo(scope.row)">指派</el-button>
                                <el-button type="text" size="mini"
                                    v-if="getCurAuth('reject_work_order') && tagsActive == '1'"
                                    :style="{ color: '#ff0000' }" @click="handleWithdraw(scope.row)">驳回</el-button>
                                <el-button type="text" size="mini"
                                    v-if="getCurAuth('reject_work_order') && tagsActive == '2'"
                                    :disabled="Number(scope.row['no_upload_material_num']) !== Number(scope.row['material_num'])"
                                    :style="{ color: Number(scope.row['no_upload_material_num']) !== Number(scope.row['material_num']) ? '#d3d3d3' : '#ff0000' }"
                                    @click="handleWithdraw(scope.row)">驳回</el-button>
                            </div>
                            <div v-else-if="column.id=='company_name'||column.id=='bloc_name'">
                                <div v-if="scope.row[column.id] && Array.isArray(scope.row[column.id])" @dblclick="copyText((scope.row[column.id]||[]).join('；'))">{{(scope.row[column.id]||[]).join('；')||'-'}}</div>
                                <span v-else @dblclick="copyText(scope.row[column.id])">{{scope.row[column.id]||'-'}}</span>
                            </div>
                            <div v-else-if="column.id === 'bloc_star'">
                                <span class="stars">{{ '★'.repeat(scope.row.bloc_star||0) }}</span>
                                <span class="star-zero" v-if="!scope.row.bloc_star">未评级</span>
                            </div>
                            <div v-else-if="column.id=='detail_info'" @dblclick="copyText(item)">
                                <div v-if="scope.row[column.id] && Array.isArray(scope.row[column.id])">
                                    <el-tooltip effect="dark" placement="top">
                                        <div @dblclick="copyTextArr(scope.row[column.id])">
                                            <div v-for="(item, i) in scope.row[column.id]" :key="i" class="mb2 mt2 ellipsis">
                                                <span>{{ item.info }}-</span>
                                                <span :class="[item.urgent_level=='加急'?'text-color-error':'']">{{item.urgent_level}}-{{item.expected_end_time}}</span>
                                            </div>
                                        </div>
                                        <div slot="content">
                                            <div v-for="(item, i) in scope.row[column.id]" :key="i" @dblclick="copyText([item.info,item.urgent_level,item.urgent_level].join('-'))" class="mb2 mt2 ellipsis">
                                                <span>{{ item.info }}-</span>
                                                <span :class="[item.urgent_level=='加急'?'text-color-error':'']">{{item.urgent_level}}-{{item.expected_end_time}}</span>
                                            </div>
                                        </div>
                                    </el-tooltip>
                                </div>
                                <span v-else>{{scope.row[column.id]||'-'}}</span>
                            </div>
                            <div v-else @dblclick="copyText(scope.row[column.id])">
                                <HoverEllipsisTips :text="scope.row[column.id]" />
                            </div>
                        </template>
                    </el-table-column>
                </jt-table>
                <PageBar :isTop="false">
                    <div class="tar pt20 pr40 pb20 bg-white">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </div>
                </PageBar>
            </div>
        </div>
    </div>
</template>

<script>

import Query from './query.vue'
import ObliqueTags from '../../../components/obliqueTags.vue'
import MaterialExtendItem from '../../../components/materialExtendItem.vue'
import {withdrawModal,batchAssignModal} from './modal'
import API from "@/api/workOrder/material";
import { fieldTableModal } from "@/views/workOrder/modal";
import { mapState, mapActions, mapMutations } from "vuex";
import HoverEllipsisTips from "@/views/workOrder/components/hoverEllipsis.vue";
import MaterialLabelCell from '@/views/workOrder/material/components/materialLabelCell.vue'
import AssignMemberWater from './assignMemberWater.vue'
import { uniqBy, find } from "lodash";
import matomoFun from "@/utils/matomo.js";
import {setStorage, getStorage, removeStorage} from '@/utils/index.js';
import {
    tagEditModal
} from '../modalMaterial'
import PageBar from '@/components/PageBar'
export default {
    name: 'AssignPage',
    components: {
        MaterialLabelCell,
        AssignMemberWater,
        HoverEllipsisTips,
        Query,
        ObliqueTags,
        MaterialExtendItem,
        PageBar
    },
    props: {
        reload: {
            type: String,
            default: ''
        },
        query: {
            type: Object,
            default: function () {
                return {}
            }
        },
        allowedPlatList: Array,
        pageFuncNames: Array,
        formatDateColor: Function,
    },
    data() {
        return {
            tableData: [],
            tags: [{
                value: '1',
                label: '待指派'
            }, {
                value: '2',
                label: '已指派'
            }],
            tagsActive: '1',
            value: '1',
            queryData: {},
            currentPage: 1,
            pageSize: 30,
            pageNum: 1,
            total: 0,
            loading: false,
            exportLoading: false,
            columns: [],
            modalList: [],
            selectList: [],
            // delivery = 落点时间（2026-08-31）：与其它时间列一样可排序。后端 getWorkOrderAssignList
            // 会把 order_fields='delivery' 换成完整子查询表达式，不依赖该列是否被勾选。
            sortList: ['order_id', 'material_num', 'expected_end_time', 'ctime', 'rejected_time', 'finish_time', 'material_end_time', 'avg_daily_cost', 'delivery'], //排序字段  前端指定
            curKey: 0,
            activated_once: 1,
            tableHeight: 'auto',
            multipleSelection:[],
            getLocalStorageWidth: {},
        }
    },
    computed: {
        ...mapState({
            uploadQueue: state => state.workOrder.workTaskList,
        }),
    },
    watch: {
        'query': {
            handler(n, o) {
                const { tagsActive } = n
                this.tagsActive = tagsActive ? tagsActive.toString() : '1'
            },
            deep: true,
            immediate: true
        },
        'tagsActive': {
            handler(val) {
                let name_list = this.tags.filter(item => item.value == val)
                let cur_name = '待指派'
                if (name_list && name_list.length !== 0) {
                    cur_name = name_list[0].label
                }
                this.CHANGE_BREADCRUMB(['指派管理', cur_name])
            },
            immediate: true
        },
    },
    created() {
        this.getLocalStorageWidth = getStorage('localStorage', 'assignTableWidthMap') || {}
    },
    mounted() {
        // this.fetchGetCustomField()
        this.CLEAR_ROUTE_CACHE()
        // 监听窗口大小变化
        window.addEventListener('resize', this.calculateTableHeight)
    },
    activated() {
        let name_list = this.tags.filter(item => item.value == this.tagsActive)
        let cur_name = '待指派'
        if (name_list && name_list.length !== 0) {
            cur_name = name_list[0].label
        }
        this.CHANGE_BREADCRUMB(['指派管理', cur_name])
        this.$nextTick(() => {
            this.$refs.refs_table.doLayout()
            if (this.activated_once !== 1 && !this.reload) {
                let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize }
                this.fetchGetList(res_params)
            }
        })
    },
    beforeDestroy() {
        // 移除窗口大小变化监听
        window.removeEventListener('resize', this.calculateTableHeight)
    },
    methods: {
        ...mapActions('workOrder', [
            'ADD_ROUTE_LIST',
            'CLEAR_ROUTE_CACHE'
        ]),
        ...mapMutations('app', [
            'CHANGE_BREADCRUMB',
        ]),
        handleTagEdit(list) {
            if(list.length == 0) {
                return this.$message.warning('请选择工单后操作');
            };
            const onSubmit = (data) => {
                this.handleCurrentChange(this.currentPage)
                vm.close()
            }
            const { vm } = tagEditModal({
                props: {
                    selectList: list,
                    type: 'order_assign',
                },
                cbs: {
                   onSubmit
                }
            })
        },
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name);
        },
        fetchGetCustomField(params) {
            this.loading = true
            API.getCustomField({ field_type: 'work_order_assign', sub_type: this.tagsActive }).then(res => {
                let result = res.data
                let user_field = result.user_field
                this.modalList = result.field ? result.field : []
                this.selectList = user_field
                let uni_fixed_data = []
                let uni_drag_data = []

                let reduce_list = this.modalList.reduce((prev, cur) => {
                    if (cur?.children.length > 0) {
                        prev.push(...cur.children);
                        return prev
                    }
                }, [])
                for (const item of user_field) {
                    reduce_list.forEach((el) => {
                        if (el.checked) {
                            if (!!el['config']) {
                                let toObjectConfig = JSON.parse(el['config'])
                                if (item == el['id']) {
                                    if (toObjectConfig['fixed']) {
                                        uni_fixed_data.push({
                                            id: el['id'],
                                            width: 150,
                                            display_name: el["display_name"],
                                            fixed: toObjectConfig['fixed'],
                                        })
                                    } else {
                                        uni_drag_data.push({
                                            id: el['id'],
                                            width: 150,
                                            display_name: el["display_name"],
                                            fixed: null,
                                        })
                                    }
                                }
                            } else {
                                if (item == el['id']) {
                                    uni_drag_data.push({
                                        id: el['id'],
                                        width: 150,
                                        display_name: el["display_name"],
                                        fixed: null,
                                        disabled: null
                                    })
                                }
                            }
                        }
                    })
                }

                let fixedData = uniqBy(uni_fixed_data, 'id')
                let dragData = uniqBy(uni_drag_data, 'id')
                this.columns = [...fixedData, ...dragData].map(item => {
                    if (item.id == 'material_status_num') {
                        item['width'] = 250
                    }
                    return item
                })
                this.$nextTick(() => {
                    // 确保表格重新计算布局
                    this.$refs.refs_table.doLayout();
                });
                this.fetchGetList({ ...params, fields: this.selectList })
            }, err => {
                this.loading = false
                this.$message.error(err.info)
            })
        },
        fetchSetCustomField(values) {
            API.editCustomField({ field_type: 'work_order_assign', fields: values, sub_type: this.tagsActive }).then(res => {
                this.$message.success('成功')
                let res_params = { ...this.queryData, order_status: this.tagsActive, pn: this.currentPage, rn: this.pageSize }
                this.fetchGetCustomField(res_params)
            }, err => {
                this.$message.error(err.info)
            })
        },
        fetchGetList(params) {
            this.loading = true
            API.postOrderAssignGetList(params).then((res) => {
                if (!params.export) {
                    this.$refs.water && this.$refs.water.reload() // v4：指派/改派/驳回后列表重拉，水位同步重拉
                    this.tableData = res?.data?.list ? res.data.list : []
                    this.total = res.data.totalCnt
                    this.tags = [{
                        value: '1',
                        label: '待指派',
                        num: res.data.no_assign_num ? res.data.no_assign_num : 0
                    }, {
                        value: '2',
                        label: '已指派',
                        num: res.data.assign_num ? res.data.assign_num : 0
                    }]
                    this.loading = false
                    this.$refs.refs_table.$forceUpdate()
                    this.calculateTableHeight()
                } else {
                    // 导出的情况
                    this.exportLoading = false
                    this.loading = false
                    this.$message.success(res.info)
                }
                this.curKey++
            }, err => {
                this.loading = false
                this.$message.error(err.info)
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 排序
        handlesortchange({ column, prop, order }) {
            // ascending 升   descending 降
            console.log(column, prop, order)
            let order_type = order == 'ascending' ? 'asc' : 'desc'
            this.queryData['order_fields'] = prop
            this.queryData['order'] = order_type
            let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize }
            this.loading = true
            this.fetchGetList(res_params)
        },
        // 排序显示
        getsortable(value) {
            if (this.sortList.includes(value)) {
                return 'custom'
            } else {
                return false
            }

        },
        // 折角矩形 标签点击
        handleTabClick(val) {
            this.$refs.refs_table.clearSort()
            this.columns = []
            this.tableData = []
            this.queryData['order_fields'] = ''
            this.queryData['order'] = ''
            let res_params = { ...this.queryData, order_status: val, pn: this.currentPage, rn: this.pageSize }
            this.loading = true
            this.fetchGetCustomField(res_params)

            this.$router.replace({
                name: 'work_order_material',
                query: {
                    topage: 'AssignPage',
                    tagsActive: val ? val.toString() : '1',
                },
                params: {
                    menuReload: 1
                }
            });
        },
        pushMatomo(name) {
            let cur_name = find(this.tags, item => item.value == this.tagsActive)
            let behaviorCategory = `素材工单(指派管理-${cur_name?.label})`
            matomoFun.trackEvent(behaviorCategory, '点击', name)
        },
        handleFieldTable() {
            this.pushMatomo('自定义列')
            const { vm } = fieldTableModal(
                {
                    props: {
                        customClass: 'custom-indicator-new apple-custom-indicator',
                        customList: this.modalList,
                        selectList: this.selectList
                    },
                    cbs: {
                        onSubmit: (data) => {
                            this.tableData = []
                            this.fetchSetCustomField(data)
                            vm.close()
                        },
                        onClose: () => {
                            vm.close()
                        }
                    }
                }
            )
        },
        handleUpdata(data) {
            this.queryData = data||{};
        },
        // 查询结果
        handleQueryClick(params) {
            if(params.status) {
                this.$refs.refs_table.clearSort()
                this.queryData['order_fields'] = ''
                this.queryData['order'] = ''
            }
            const {order_fields, order} = this.queryData
            this.queryData = {order_fields:order_fields, order:order, ...params.params}||{}
            let res_params = {...this.queryData, order_status: this.tagsActive, pn: this.currentPage, rn: this.pageSize }
            this.fetchGetCustomField(res_params)
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize }
            this.fetchGetList(res_params)
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize }
            this.fetchGetList(res_params)
        },
        // 导出
        async exportData() {
            this.pushMatomo('导出')
            try {
                this.exportLoading = true
                let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize, export: '1' }
                await this.fetchGetList(res_params)
                // await this.getList()
            } catch (error) { } finally {
                this.exportLoading = false
            }
        },
        /**
         * show_type  展开详情的方式 true 全部展开  false
         * show_status  展开详情的状态
         * */
        handleRouteInfo(rows, show_type, show_status) {
            // if(show_status) {
            //     this.$emit('changePage','TaskInfoPage',{fromPage: 'AssignPage',order_id:rows.order_id, tagsActive:1, show_type:show_type, show_status:show_status});
            // }else{
            //     this.$emit('changePage','TaskInfoPage',{fromPage: 'AssignPage',order_id:rows.order_id, tagsActive:1, show_type:show_type});
            // }
            this.pushMatomo('列表(需求数量进入详情)')
            this.ADD_ROUTE_LIST(this.query)
            this.$router.push({
                name: 'work_order_material',
                query: {
                    formpage: 'AssignPage',
                    topage: 'TaskInfoPage',
                    id: rows.order_id,
                    tagsActive: '1',
                    show_type: show_type ? show_type : false,
                    show_status: show_status ? show_status : ''
                },
                params: {
                    menuReload: 1
                }
            });
        },
        // 指派
        handleInfo(rows) {
            this.pushMatomo('列表(指派)')
            this.ADD_ROUTE_LIST(this.query)
            this.$router.push({
                name: 'work_order_material',
                query: {
                    formpage: 'AssignPage',
                    topage: 'AssignInfoPage',
                    id: rows.order_id,
                    tagsActive: this.tagsActive ? this.tagsActive.toString() : '1'
                },
                params: {
                    menuReload: 1
                }
            });
            this.activated_once++
            // this.$emit('changePage','AssignInfoPage', {order_id:rows.order_id, tagsActive:this.tagsActive});
        },
        // 批量指派
        batchAssign(){
            if(this.multipleSelection.length == 0) {
                return this.$message.warning('请选择工单后操作');
            }
            let actionRows = this.multipleSelection.filter(item=>{
                if(this.uploadQueue.some(task=>task.order_id == item.order_id)) return false;
                if(this.tagsActive == '2'&&(+item.no_upload_material_num!=+item.material_num)){
                    return false;
                }
                return true;
            });



            this.pushMatomo('列表(批量指派)');
            let orderIds = actionRows.map(item=>item.order_id).join(',');
            console.log('batchAssign',orderIds, actionRows);
            const {vm} = batchAssignModal({
                props: {
                    id:orderIds,
                    list:actionRows,
                    base: 0
                },
                cbs:{
                    onSubmit:(data)=>{
                        this.handleQueryClick({
                            params:this.queryData,
                        });
                    },
                },
            })
        },
        // 批量改派
        batchChangeAssign(){
            if(this.multipleSelection.length == 0) {
                return this.$message.warning('请选择工单后操作');
            }
            let actionRows = this.multipleSelection;
            let orderIds = actionRows.map(item=>item.order_id).join(',');
            const {vm} = batchAssignModal({
                props: {
                    id:orderIds,
                    list:actionRows,
                    base: 2,
                    title: '批量改派',
                },
                cbs:{
                    onSubmit:(data)=>{
                        this.handleQueryClick({
                            params:this.queryData,
                        });
                    },
                },
            })
        },
        // 批量驳回
        batchReject(){
            console.log('batchReject');
            if(this.multipleSelection.length == 0) {
                return this.$message.warning('请选择工单后操作');
            }
            let orderIds = this.multipleSelection.map(item=>item.order_id).join(',');
            console.log('batchReject-actionRows',orderIds);
            this.pushMatomo('列表(批量驳回)')

            let cur_name = find(this.tags, item => item.value == this.tagsActive)
            let behaviorCategory = `素材工单(指派管理-${cur_name?.label})`
            const { vm } = withdrawModal(
                {
                    props: {
                        id: orderIds,
                        name: behaviorCategory,
                    },
                    cbs: {
                        onSubmit: () => {
                            this.handleQueryClick({
                                params: this.queryData,
                            });
                        },
                    },
                    on: {
                        close: () => {
                            vm.close()
                            this.pushMatomo('列表(驳回-取消)')
                        }
                    }
                }
            )
        },
        // 驳回 弹框
        handleWithdraw(rows) {
            let isEqul = this.uploadQueue.some(item => item.order_id == rows.order_id)
            if (isEqul) {
                return this.$message.warning('素材正在上传中，无法继续操作')
            }
            this.pushMatomo('列表(驳回)')
            let cur_name = find(this.tags, item => item.value == this.tagsActive)
            let behaviorCategory = `素材工单(指派管理-${cur_name?.label})`
            const { vm } = withdrawModal(
                {
                    props: {
                        id: rows.order_id,
                        name: behaviorCategory,
                    },
                    cbs: {
                        onSubmit: (data) => {
                            vm.close()

                            let res_params = { ...this.queryData, order_status: this.tagsActive, pn: this.currentPage, rn: this.pageSize }
                            this.fetchGetCustomField(res_params)
                        },
                    },
                    on: {
                        close: () => {
                            vm.close()
                            this.pushMatomo('列表(驳回-取消)')
                        }
                    }
                }
            )
        },
        // 复制文本到剪贴板
        copyText(text) {
            if (!text || text === '-') return
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            this.$message.success('复制成功');
        },
        copyTextArr(arr) {
            if (!arr || arr.length == 0) return
            const text = arr.map(item => `${item.info}-${item.urgent_level}-${item.expected_end_time}`).join('；')
            this.copyText(text)
        },
        // 计算表格最大高度
        calculateTableHeight() {
            const height = window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            let tableContainerHeight = 0
            this.$nextTick(() => {
                // 获取容器元素
                const container = this.$el.querySelector('.el-table__body')
                if (container) {
                    // 计算容器高度减去头部和底部区域
                    tableContainerHeight = container.offsetHeight
                } else {
                    tableContainerHeight = 0
                }
                if (tableContainerHeight >= height - 200) {
                    this.tableHeight = 'calc(100vh - 120px)'
                } else {
                    this.tableHeight = 'auto'
                }
            })
        },
        handleDragEnd(newWidth, oldWidth, column) {
            let getCurrentNameWidth = this.getLocalStorageWidth || {}
            //存储示例格式 {address: 707, date: 184, name: 246}
            let result = Object.assign(getCurrentNameWidth, {
                [column.property]: parseInt(newWidth),
            });
            setStorage('localStorage', 'assignTableWidthMap', Object.assign({},this.getLocalStorageWidth,result));
        },
    }
}
</script>
<style lang="scss" scoped>
@import "~@/styles/material_sd.scss";
</style>
<style>
.custom-indicator-new {
    min-width: 900px;
}
</style>
<style scoped lang="scss">
.tab-box {
    i {
        display: none;
        cursor: pointer;
        color: rgb(64, 158, 255);
    }
    &:hover {
        i {
            display: inline;
        }
    }
}
.stars { color: #f7ba2a; letter-spacing: 1px; }
.star-zero { color: #c0c4cc; }
/* §11 扩展：操作区进吸顶块后用块内间距 */
.operation-box.op-box-in-affix { margin-bottom: 6px; }
</style>
